export default "__VITE_ASSET__BmQwQqGM__"